// noinspection ES6CheckImport
import {collection, query, onSnapshot} from "firebase/firestore";
import { createSlice } from '@reduxjs/toolkit'
import {firestore} from "firebase.js";


// =========================== Slice ===========================
export const inquirySlice = createSlice({
  name: 'inquiry',
  initialState: {
    inquiries: [],
  },
  reducers: {
    set: (state, action) => {
      state.inquiries = action.payload
    }
  },
})

// ============================= Actions =============================
export const { set } = inquirySlice.actions;

// ============================= Thunks =============================
export const fetchAllInquiries = () => async dispatch => {
  const q = query(collection(firestore, 'inquiries'))
  onSnapshot(q, (querySnapshot) => {
    const inquiries = [];
    querySnapshot.forEach((doc) => {
      inquiries.push({...doc.data(), ...{id: doc.id}})
    });
    dispatch(set(inquiries))
  })
};

// ============================ Selectors ============================
export const selectInquiries = state => state.inquiry.inquiries;


// =========================== Default Export =========================
export default inquirySlice.reducer
